export const SET_DATA = (state, { id, data }) => {
  state[id] = data;
};
export const PUSH_DATA = (state, { id, data }) => {
  state[id].push(data);
};
export const toggleSidebarDashboard = (state, val) => {
  state.openSideDashboard = !val;
};
export const closeDebarDashboard = (state, val) => {
  state.openSideDashboard = false;
};
export const toggleSubMenu = (state, val) => {
  state[val.isMenu][val.index].show = val.show;
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/sidebar/mutations.js